module.exports = __webpack_public_path__ + "static/media/profile-picture-5.cb7f167c.jpg";